declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, CaseRegistrationByActorCodeController, CaseRegistrationByActorCodeRequest, DeletePatientRequest, GenericProcPostRequest, S_Methods } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbAddNewPatient } from './modal/addnewpatient.modal';
import { NgbCameraUploadModal } from '../../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';
import { NgbAddNewEnquiry } from './modal/addnewenquiry.modal';
import { NgbAddbilladv } from '../../opbilling/modal/addbilladv.modal';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';





@Component({
  selector: 'providerdashboard',
  templateUrl: './providerdashboard.component.html',
  styleUrls: [
    './providerdashboard.component.scss']
  , animations: [routerTransition()]
})

export class ProviderDashboardComponent implements OnInit {
  //  parserFormatter: any;

  OnGoBack() {
    //alert("I cam bak");
    this.ShowList = true;
    this.HasPartnerData = false;
  }
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
  public ShowListView: boolean = false;
  public ActorCode: number = 0;
  //public FormattedCode: string;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowRegister: boolean = true;
  public isdisplaydate: boolean = false;
  public Showrow: boolean = true;
  public Selectedtoday: string = '';
  public SelectedDuration: string = '';
  SelectedFromDate: NgbDateStruct;
  SelectedToDate: NgbDateStruct;
  TodayDate = new Date();
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  RefreshPatients(st: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = this.SelectedFacilityCode;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = st;

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetPatientInfoByFormattedCodeController();
  }
  _GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();

    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (this.ApiResData && !this.ApiResData.hasError) {
          const rawResult = this.ApiResData.Result || (this.ApiResData as any).result || [];
          this.CurrentPatientInfoByFormattedCodeController = rawResult;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }
      );
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();

    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (this.ApiResData && !this.ApiResData.hasError) {
          const rawResult = this.ApiResData.Result || (this.ApiResData as any).result || [];
          this.CurrentPatientInfoByFormattedCodeController = rawResult;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService,
    private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {
    this.SelectedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();
    //this.FormattedCode = this.SelectedPatient.FormattedCode;

    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.isNew = true;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedPatient.FormattedCode;
    this.LoadPatients();
    //this.GetPatientInfoByFormattedCodeController();

  }
  public DisplayTable: boolean = false;
  public DisplayCard: boolean = true;
  DisplayStyle(Type: string) {
    if (Type == 'List') {
      this.DisplayTable = true;
      this.DisplayCard = false;
    }
    else if (Type == 'Card') {
      this.DisplayCard = true;
      this.DisplayTable = false;
    }
  }

  public SelectedFacilityCode: number;
  SelectedFacilityName: string;
  Branchdata(event: any) {

    if (event != null) {

      // alert(event);
      this.SelectedFacilityName = event;
    }

  }
  onSubmit(e) {

    if (e.target.checked) {

      this.isdisplaydate = true;
      this.SelectedDuration = 'nameB';
    }
    else if (!e.target.checked) {
      //this.isdisplaydate = false;
      this.SelectedDuration = '';
    }

  }
  onSubmit2(e) {

    if (e.target.checked) {
      this.isdisplaydate = false;
      this.Selectedtoday = 'nameA';
    }
    else if (!e.target.checked) {
      //this.isdisplaydate = false;
      this.Selectedtoday = '';
    }

  }

  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  AddNewPatient() {

    const modalRef = this.modalService.open(NgbAddNewPatient,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
    //modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  }
  AddNewEnquiry() {
    const modalRef = this.modalService.open(NgbAddNewEnquiry,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  }


  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  CurrentCaseRegistrationByActorCodeController: CaseRegistrationByActorCodeController[];
  PatientDetailsData: CaseRegistrationByActorCodeController;
  CurrentCaseRegistrationByActorCodeRequest: CaseRegistrationByActorCodeRequest;

  LoadCouple() {
    //alert("ScansData")
    this.CurrentCaseRegistrationByActorCodeRequest = new CaseRegistrationByActorCodeRequest();

    this.CurrentCaseRegistrationByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCaseRegistrationByActorCodeController();
  }
  PartnerFormattedCode: string;
  PartnerDisplayName: string;
  HasPartnerData: boolean;
  GetCaseRegistrationByActorCodeController() {
    this.StartRefreshing();

    this.CurrentCaseRegistrationByActorCodeRequest.ActorCode = this.SelectedPatient.ActorCode;
    //this.CurrentCaseRegistrationByActorCodeRequest.FromDate = new Date();
    //this.CurrentCaseRegistrationByActorCodeRequest.ToDate = new Date();
    this.CurrentCaseRegistrationByActorCodeRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentCaseRegistrationByActorCodeRequest.ConditionalOperator = 10;
    this.actorservice.GetCaseRegistrationByActorCodeController(this.CurrentCaseRegistrationByActorCodeRequest)
      .subscribe((result) => {
        this.stopRefreshing();
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          
          this.CurrentCaseRegistrationByActorCodeController = this.ApiResData.Result;
          if (this.CurrentCaseRegistrationByActorCodeController.length > 0) {
            this.PatientDetailsData = this.CurrentCaseRegistrationByActorCodeController[0];


            if (this.SelectedPatient.FormattedCode == this.PatientDetailsData.FFormattedCode) {
              this.PartnerFormattedCode = this.PatientDetailsData.MFormattedCode;
              this.PartnerDisplayName = this.PatientDetailsData.MDisplayName;
              this.HasPartnerData = true;
            }
            else {
              this.PartnerFormattedCode = this.PatientDetailsData.FFormattedCode;
              this.PartnerDisplayName = this.PatientDetailsData.FDisplayName;
              this.HasPartnerData = true;
            }
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  SelectedPartner: PatientInfoByFormattedCodeController;
  SelectedPatient: PatientInfoByFormattedCodeController;

  ViewPatientDetails(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {



      this.ShowPatientDetails = true;
      this.ShowList = false;
      this.SelectedPatient = patient;
      this.Showarrow = true;
      this.Showrow = false;
      this.ShowRegister = false;

      this.HasPartnerData= false;
      
      // load partner details..
      this.LoadCouple();
      //this.LoadPatientdetails()
      //alert(patient.FormattedCode);
      //this.FormattedCode = patient.FormattedCode;
    }
    else {
      this.ShowPatientDetails = false;
    }
  }
  SelectedPatientDetails: PatientInfoByFormattedCodeController;
  SelectedPatientdet(objCategory: any) {
    var patient2: PatientInfoByFormattedCodeController = objCategory;

    if (patient2 != null) {
      this.SelectedPatientDetails = null;
      this.SelectedPatientDetails = patient2;
    }

  }
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}
  DeletePatient(l) {
    swal({
      title: 'Are you sure?',
      text: "You want to delete!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.DeleteRegPatient(l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  DeleteRegPatient(l) {
    var saveReq = new DeletePatientRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 80130;
    saveReq.ActorCode = l.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.FormattedCode = l.FormattedCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 80130;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadPatients();
            //this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  criteriaChange(value: string) {
    this.RefreshPatients(value);


  }
  criteriaChange2(value: string) {
    this.RefreshPatients(value);


  }
  capture(l: PatientInfoByFormattedCodeController) {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = l.ActorCode;
    modalRef.componentInstance.Photo = l.Photo;
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    this.RefreshPatients(this.searchValue);
  }
  dataChanged(newobj) {
    this.RefreshPatientsByDate();
  }
  RefreshPatientsByDate() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = this.SelectedFacilityCode;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetPatientInfoByFormattedCodeController();
  }
  DecrementDate(Value: any) {
    var monthNo = this.SelectedToDate.month
    var d: Date = new Date(
      this.SelectedToDate.year,
      monthNo - 1,
      this.SelectedToDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedToDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this.RefreshPatientsByDate();
  }
  IncrementDate(Value: any) {
    var monthNo = this.SelectedToDate.month
    var d: Date = new Date(
      this.SelectedToDate.year,
      monthNo - 1,
      this.SelectedToDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedToDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this.RefreshPatientsByDate();
  }
  Go() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = this.SelectedFacilityCode;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
    if (this.isdisplaydate) {
      this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = true;
      this.CurrentPatientInfoByFormattedCodeRequest.IsToday = false;
    }
    else if (!this.isdisplaydate) {
      this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
      this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    }
    //this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;

    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetPatientInfoByFormattedCodeController();
  }
  Addbill(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {

      this.router.navigate(['healins/receiptold', {
        FormattedCode: patient.FormattedCode,
      }]);
    }
  }
  Addbill_withSvcProvider(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {

      this.router.navigate(['healins/receipt_svcprovider', {
        FormattedCode: patient.FormattedCode,
      }]);
    }
    //this.router.navigate(['healins/receipt_svcprovider', { FormattedCode: this.FormattedCode }]);
  }
  AddRxbill(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {
      this.Guest(patient.FormattedCode, 'Registered');
    }
  }
  Guest(FormattedCodedata: string, PatientType: string) {
    if (PatientType == 'Registered') {
      this.router.navigate(['healins/rxreceipt', { FormattedCodedata: FormattedCodedata, PatientType: PatientType }]);
     // this.activeModal.close();
    }
    else if (PatientType == 'Guest') {
      //this.router.navigate(['healins/rxreceipt', { FormattedCodedata: this.GuestDetails.FormattedCode, GuestName: (this.GuestSalutation + ' ' + this.GuestName), GuestPhone: this.GuestPhone, PatientType: PatientType }]);
    //  this.activeModal.close();
    }
  }

  AddAdv(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {
      //alert(patient.FormattedCode);
      const modalRef = this.modalService.open(NgbAddbilladv,
        {
          centered: true,
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        })
      modalRef.componentInstance.FomattedCode = patient.FormattedCode;
      modalRef.componentInstance.Type = "FromProfile"
      modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() });
    }
  }

}
